import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openSiteStylesModal } from 'store/modules/pageBuilder';
import styles from './styles.scss';

const propTypes = {
  openStylesModal: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
};

const defaultProps = {};

const SiteStylesHelpLink = ({ openStylesModal, message, linkText }) => (
  <span className={styles.message}>
    {message} <button type="button" onClick={() => openStylesModal()}>{linkText}</button>.
  </span>
);

SiteStylesHelpLink.propTypes = propTypes;
SiteStylesHelpLink.defaultProps = defaultProps;
export default connect(
  null,
  {
    openStylesModal: openSiteStylesModal,
  },
)(SiteStylesHelpLink);
